import React, { useEffect, useState } from "react";
// Components
import TextInput from "view/pages/MyProfile/Components/Inputs/TextInput";
import InputField from "view/components/InputField";
import Button from "view/components/Button";
import MultiSelect from "view/components/Multiselect";
import GooglePlacesAutocomplete from "Components/AddressInput";
import apiLibrary from "services/api";

type FileInfoProps = {
  handleClose: () => void;
  values: any;
  handleChange: any;
  handleBlur: any;
  errors: any;
  touched: any;
  setFieldValue: any;
  isSubmitting: any;
  isEdit: any;
};

export const FileInfo = ({
  handleClose,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  isSubmitting,
  isEdit,
}: FileInfoProps) => {
  const [speciesOption, setSpeciesOption] = useState([
    {
      value: "",
      label: "",
    },
  ]);
  const locationOptions = [
    { label: "Lahore", value: "lahore" },
    { label: "Karachi", value: "karachi" },
    { label: "Islamabad", value: "islamabad" },
    { label: "Multan", value: "multan" },
    { label: "Peshawar", value: "peshawar" },
  ];

  const categoryOptions = [
    { label: "Biological", value: "biological" },
    { label: "Social", value: "social" },
    { label: "Economic", value: "economic" },
    { label: "Educational", value: "educational" },
    { label: "Outreach", value: "outreach" },
  ];

  const statusOptions = [
    { label: "Ongoing", value: "ongoing" },
    { label: "Complete", value: "complete" },
    { label: "Retired", value: "retired" },
    { label: "Not Released", value: "not_released" },
    { label: "Publicly", value: "publicly" },
  ];

  const fetchAllSpecies = async () => {
    try {
      const response =
        await apiLibrary.DataPortal.getDataPortalDropDown("specie");
      const formattedSpecieData = response?.data?.specie?.map((item: any) => ({
        value: item.id,
        label: item.name,
      }));
      setSpeciesOption(formattedSpecieData); // Uncomment and use this to update state
    } catch (error) {
      console.error("Error fetching species:", error);
    }
  };

  useEffect(() => {
    fetchAllSpecies();
  }, []);
  return (
    <>
      {/* this is second step */}
      <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 py-4 px-6 bg-white overflow-y-auto h-full">
        <div className="relative flex items-center self-stretch justify-start flex-grow-0 flex-shrink-0 gap-4 py-4 rounded-lg mb-3">
          <button onClick={handleClose}>
            {" "}
            <svg
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="relative flex-grow-0 flex-shrink-0 w-6 h-6"
              preserveAspectRatio="xMidYMid meet"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                className="dark:fill-textMain fill-[#2C3236]"
              />
            </svg>
          </button>
          <div className="flex items-center justify-start flex-grow">
            <div className="flex justify-start items-center text-secondaryMid flex-grow relative py-0.5">
              <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center capitalize text-textMid dark:text-textMain">
                {isEdit ? "Edit info" : "File Info"}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col">
          <div className="w-full">
            <TextInput
              type="text"
              label="Title*"
              placeholder="Type Title Here"
              name="title"
              value={values.title}
              error={errors?.title}
              touched={touched.title}
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </div>
          <div className="w-full">
            <TextInput
              type="text"
              label="Description*"
              placeholder="Description"
              fieldAs="textarea"
              rows={3}
              name="description"
              value={values.description}
              error={errors?.description}
              touched={touched.description}
              handleChange={handleChange}
              handleBlur={handleBlur}
              helperText={"6000 Max Characters"}
            />
          </div>
          <div className="w-full">
            <InputField
              type="date"
              label="Creation Date"
              placeholder="YYYY/MM/DD"
              className={"py-[-2px] w-full"}
              name="materialCreationDate"
              value={values.materialCreationDate}
              error={errors?.materialCreationDate}
              touched={touched.materialCreationDate}
              onChange={(values: any) =>
                setFieldValue("materialCreationDate", values)
              }
              onBlur={handleBlur}
            />
          </div>

          <div className="w-full pt-2">
            <TextInput
              label="Organization"
              type="text"
              placeholder="Enter Organization Name"
              name="organization"
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              handleBlur={handleBlur}
              value={values.organization}
              error={errors?.organization}
              touched={touched.organization}
            />
          </div>

          <div className="w-full">
            <TextInput
              label="Author"
              type="text"
              placeholder="Enter Author Name"
              name="author"
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.author}
              error={errors?.author}
              touched={touched.author}
            />
          </div>

          <div className="w-full">
            <TextInput
              label="Publisher"
              type="text"
              placeholder="Enter Publisher Name"
              name="publisher"
              handleChange={handleChange}
              handleBlur={handleBlur}
              value={values.publisher}
              error={errors?.publisher}
              touched={touched.publisher}
            />
          </div>

          <div className="w-full pt-2">
            <p className="w-full pb-1 text-sm font-medium text-left capitalize text-textMid dark:text-caption">
              Species
            </p>
            <MultiSelect
              name="specieId"
              placeholder="Select Species"
              options={speciesOption}
              // isDisable={editProgramModal?.data}
              // inputValue={searchString}
              onInputChange={(value: string) => {}}
              className={
                "border border-lineDark dark:border-lineLight rounded-md capitalize text-textMid dark:text-caption"
              }
              defaultValue={{ value: "", label: "" }}
              isMulti={false}
              closeOnSelect={true}
              value={values.specieId}
              onChange={(option: any) => {
                setFieldValue("specieId", option);
              }}
            />
          </div>

          <div className="w-full pt-2 mt-2">
            <p className="w-full pb-1 text-sm font-medium text-left capitalize text-textMid dark:text-caption">
              Categories
            </p>
            <MultiSelect
              name="category"
              placeholder="Select Category"
              options={categoryOptions}
              // isDisable={editProgramModal?.data}
              // inputValue={searchString}
              onInputChange={(value: string) => {}}
              className={
                "border border-lineDark dark:border-lineLight rounded-md capitalize"
              }
              defaultValue={{ value: "", label: "" }}
              isMulti={false}
              closeOnSelect={true}
              value={values.category}
              onChange={(option: any) => {
                setFieldValue("category", option);
              }}
            />
          </div>

          <div className="w-full pt-4">
            <p className="w-full pb-1 text-sm font-medium text-left capitalize text-textMid dark:text-caption">
              Status
            </p>
            <MultiSelect
              name="status"
              placeholder="Select Status"
              options={statusOptions}
              // isDisable={editProgramModal?.data}
              // inputValue={searchString}
              onInputChange={(value: string) => {}}
              className={
                "border border-lineDark dark:border-lineLight rounded-md capitalize"
              }
              defaultValue={{ value: "", label: "" }}
              isMulti={false}
              closeOnSelect={true}
              value={values.status}
              onChange={(option: any) => {
                setFieldValue("status", option);
              }}
            />
          </div>

          <div className="flex items-center self-stretch justify-start py-3 mt-1">
            <GooglePlacesAutocomplete
              label="Location"
              onBlur={handleBlur}
              placeholder="Select Location"
              hanndleAddressSelect={(address: any) => {
                console.log(address,'address')
              }}
              location={values.location}
              handleLatitudeAndLongitude={(longitude: any, latitude: any) => {
                setFieldValue("location.lat", latitude);
                setFieldValue("location.long", longitude);
              }}
            />
          </div>

          <div className="flex justify-end gap-2 pb-4 pt-4">
            <Button
              type="button"
              text="Cancel"
              filledColor="primary"
              outlinedColor="primary"
              textColor="textWhite"
              className="w-24 py-2"
              width="35"
              height="13"
              fontStyle="font-semibold"
              variant="outlined"
              onClick={handleClose}
            />
            <Button
              type="submit"
              disabled={isSubmitting}
              text="Save"
              filledColor="primary"
              outlinedColor="primary"
              textColor="textWhite"
              className="w-24 py-2"
              width="35"
              height="13"
              fontStyle="font-semibold"
              variant="filled"
            />
          </div>
        </div>
      </div>
    </>
  );
};
